<template>
  <Layout>
  <DsIslandsContainer>
    <DsIsland>
      <DsResultBanner
        type="neutral"
        size="small"
        title=""
      >
        <template #title>
          <span v-html="translate('goldkid-open-failed:title-not-found')"></span>
        </template>
      </DsResultBanner>
    </DsIsland>
    <DsIsland>
      <DsCell multiline>
        <template #default>
          <span v-html="translate('goldkid-open-failed:call-center-not-found')"></span>
        </template>
        <template #right>
          <DsButton @click="sendAnalytic" type="tinted" icon="system/phone-400" size="small">1414</DsButton>
        </template>
      </DsCell>
    </DsIsland>
    <DsIsland>
      <snippet
        v-if="isGuideEnabled"
        :lang="getLocalePlease"
        code="KaspiGoldKidNoData"
        :title="translate('kid-list:guide-title')"
        :contour="guideContour"/>
    </DsIsland>
    <DsButtonBar sticky>
      <DsButton size="large" @click="goHome">
        {{ translate('goldkid-open-failed:btn') }}
      </DsButton>
    </DsButtonBar>
  </DsIslandsContainer>
  </Layout>
</template>
<script setup>
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import { DsResultBanner, DsCell ,DsIsland, DsIslandsContainer, DsButtonBar, DsButton } from '@ds/vue2';
import { snippet } from '@guide/guide-snippet-vue2';
import "@guide/guide-snippet-vue2/styles"
import { computed, onBeforeUnmount, onMounted } from 'vue';
import translate from "@/filters/translate.filter"
import { getLocale } from '@/modules/locale/locale'
import useStore from '@/composables/useStore';
import useHeader from '@/composables/useHeader';
import { getDeviceType } from '@/helpers/getDeviceType';
import Layout from '@/components/ui/Layout/Layout.vue'
const store = useStore()
const {hideBackBtn} = useHeader()
hideBackBtn()

const goHome = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}
const getLocalePlease = computed(() => {
  return getLocale() === 'ru-RU' ? 'ru' : 'kz'
})
const isGuideEnabled = computed(() => {
  return store.getters['goldkidProcess/isGuideTipsEnabled']
})
const isIos = () => {
  return getDeviceType() === 'ios'
}
const guideContour = process.env.VUE_APP_GUIDE_CONTOUR

const sendAnalytic = () => {
  sendAnalyticEvent('online_child_gold_call_center_click', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    inner_source: ['online_child_gold_rejected'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
  window.location.href='tel:1414'
}

onMounted(() => {
  sendAnalyticEvent('online_child_gold_rejected', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    reject_reason: [translate('no-kid-found:title')],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})

onBeforeUnmount(() => {
  sendAnalyticEvent('online_child_gold_call_center_click', {
    stage: ['finish']
  })
})
</script>
